export const appendFormData = (formData, data, parentKey = '') => {
  if (data == null) {
    return;
  }

  for (const key in data) {
    if (!data.hasOwnProperty(key)) {
      continue;
    }

    const value = data[key];

    if (value === null || value === undefined) {
      continue;
    }

    const formKey = parentKey ? `${parentKey}[${key}]` : key;

    if (typeof value === 'object' && !(value instanceof File)) {
      appendFormData(formData, value, formKey);
    } else {
      formData.append(formKey, value);
    }
  }
}
